import { render, staticRenderFns } from "./BtnObterDotacoesProcesso.vue?vue&type=template&id=722ca0bc"
import script from "./BtnObterDotacoesProcesso.vue?vue&type=script&lang=js"
export * from "./BtnObterDotacoesProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports